export * from './__generated__/proposals.generated'
